// api/getHoldingDepositRecordById.ts
import { HoldingDepositRegister } from "../models/holdingdepositregister.model";
import { responseHero } from "../utils/axiosInterceptor";

export const getHoldingDepositRecordById = (id: number): Promise<HoldingDepositRegister> => {
    return new Promise<HoldingDepositRegister>((resolve, reject) => {
        if (!id) return reject(new Error("Hiányzó id"));

        responseHero.get(`${process.env.REACT_APP_API_URL}/humandc/holdingdepositregister/${id}`)
            .then((response) => resolve(response.data as HoldingDepositRegister))
            .catch(error => {
                console.error(error);
                reject(error);
            });
    });
};